import { render, staticRenderFns } from "./buyComp.vue?vue&type=template&id=9067ebae"
import script from "./buyComp.vue?vue&type=script&lang=js"
export * from "./buyComp.vue?vue&type=script&lang=js"
import style0 from "./buyComp.vue?vue&type=style&index=0&id=9067ebae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports